import { render, staticRenderFns } from "./OfferImgZoom.vue?vue&type=template&id=d8137dd2&scoped=true&"
import script from "./OfferImgZoom.vue?vue&type=script&lang=js&"
export * from "./OfferImgZoom.vue?vue&type=script&lang=js&"
import style0 from "./OfferImgZoom.vue?vue&type=style&index=0&id=d8137dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8137dd2",
  null
  
)

export default component.exports